import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { ShopWorkCassette } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/uiParts/ShopWorkCassette";
import { type FC } from "react";
import { type ModalInnerProps } from "@userFrontend/features/publication/components/ScoutCassette/type";
import { GA_INNER_CASSETTE_ACTION } from "@userFrontend/features/publication/components/ScoutCassette/constants";
import * as styles from "./styles.css";

export const ModalInner: FC<ModalInnerProps> = ({
  cassettes,
  scoutMailUrl,
  isShowIndicator,
  indicatorRef,
  handleClickLink,
}) => {
  const generateWorkCode = (detailUrl: string) => {
    const matchedWorkCode = /job\/([^/]+)\/sid(?:.*)$/.exec(detailUrl);
    return matchedWorkCode ? matchedWorkCode[1] : "null";
  };
  return (
    <>
      <GuidanceBox themeColor="pink">
        <p className={styles.shopModalGuidanceBoxInner}>
          <span className={styles.shopModalIconOuter}>
            <Icon name="location" />
          </span>
          勤務地は選考で相談できます。
        </p>
      </GuidanceBox>
      <div className={styles.shopModalContainer}>
        {cassettes.map((cassette) => {
          const matchedClientShopId = /.*_(.*)$/.exec(cassette.docId);
          const gaLabel = `${generateWorkCode(cassette.url)}_${matchedClientShopId ? matchedClientShopId[1] : "null"}`;
          const scoutMailUrlWithOverrideShopId = matchedClientShopId
            ? `${scoutMailUrl}?override_shop_id=${matchedClientShopId[1]}`
            : scoutMailUrl;
          return (
            <div key={cassette.docId} className={styles.shopCassetteOuter}>
              <ShopWorkCassette
                {...cassette}
                url={
                  scoutMailUrl && scoutMailUrlWithOverrideShopId
                    ? scoutMailUrlWithOverrideShopId
                    : cassette.url
                }
                handleClickLink={handleClickLink}
                scoutGaAction={GA_INNER_CASSETTE_ACTION}
                entryGaAction={GA_INNER_CASSETTE_ACTION}
                gaLabel={gaLabel}
              />
            </div>
          );
        })}
      </div>
      {isShowIndicator && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} ref={indicatorRef} />
        </div>
      )}
    </>
  );
};
